// Breadcrumbs Ellipsis
jQuery.fn.breadcrumbs = function(options) {
    var el = jQuery(this);

    // truncate individual titles if over set length
    var crumbCounter = 0;
    jQuery('a', el).each(function() {
        var crumbTitle = jQuery(this).text();
        if (crumbTitle.length > options.crumbMaxLength) {
            jQuery(this).text(
              jQuery.trim(crumbTitle).substring(0, 100).split(" ").slice(0, -1).join(" ") + "....."
            );
        }
        crumbCounter++;
    });

    // remove the link from the current page crumb
    jQuery('.active', el).replaceWith(
      jQuery('<span/>').text(jQuery('.active', el).text())
    );

    var crumbs = jQuery.map(jQuery('a, span', el).toArray(), function(x) {
        return '<li class="usa-breadcrumb__list-item">' + x.outerHTML + '</li>';
    });

    // Create crumb for the current page
    if (crumbCounter >= 1) {
        var currentPageCrumbString = jQuery(document).attr('title');
        var currentPageCrumb = '<li class="usa-breadcrumb__list-item"><span>' + currentPageCrumbString.split('|')[0] + '</span></li>';
    } else {
        var currentPageCrumb = '';
    }

    el.html(crumbs.join('') + currentPageCrumb);
};

jQuery('.breadcrumbs').breadcrumbs({
    maxLevels: 3,
    startCrumbs: 2,
    endCrumbs: 3,
    crumbMaxLength: 100
});
